import React from 'react';
import MenuModal from './Navbar/Menu/Modal';
import MobileNavigationNavbar from './Navbar';
import { useShowNavigation } from '@/hooks/useShowNavigation';
import NotificationsModal from '../Notifications/NotificationModal';

export default function MobileNavigation() {
  const showNavigation = useShowNavigation();

  if (!showNavigation) {
    return null;
  }

  return (
    <React.Fragment>
      <MenuModal />
      <NotificationsModal />
      <MobileNavigationNavbar />
    </React.Fragment>
  );
}
